import { createFileRoute, notFound } from "@tanstack/react-router"

import { authorDescription, authorSchema, authorUrl } from "@/lib/blog-authors"
import { getAuthorPosts } from "@/lib/blog-posts"
import { RSS_FEED_LINK } from "@/lib/rss-meta"
import { seoMeta } from "@/lib/seo"

import { BlogAuthorPage } from "../-components/BlogAuthorPage"

export const Route = createFileRoute("/_content/blog/authors/$slug")({
  loader: async ({ params }) => {
    const { blogAuthors } = await import("@/lib/blog-posts")
    const author = blogAuthors.find((author) => author.slug === params.slug)
    if (!author) throw notFound()
    return { author }
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    const author = loaderData.author
    const url = authorUrl(author)
    return {
      ...seoMeta({
        title: `${author.name} · Articles`,
        description: authorDescription(author),
        url,
        type: "profile",
        image: `https://entire.com/og/author/${encodeURIComponent(author.slug)}.png`,
        imageAlt: `${author.name} · ${author.title}`,
        extraLinks: [RSS_FEED_LINK],
      }),
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfilePage",
            url,
            name: author.name,
            mainEntity: authorSchema(author),
          }),
        },
      ],
    }
  },
  component: BlogAuthorRoute,
})

function BlogAuthorRoute() {
  const { author } = Route.useLoaderData()
  return <BlogAuthorPage author={author} posts={getAuthorPosts(author.slug)} />
}
